<div class="container">
  <div class="row">
    <div class="col-12">
      <div class="page-title">
        <app-company-product-page-identity />
        <h1>{{ page_title }}</h1>
        <div class="page-title-actions">
          <app-month-navigation
            [selected_month]="selected_month()"
            [display_label]="selected_month_label()"
            [can_go_to_next_month]="can_go_to_next_month()"
            [can_go_to_current_month]="can_go_to_current_month()"
            (previous_month)="goToPreviousMonth()"
            (next_month)="goToNextMonth()"
            (current_month)="goToCurrentMonth()"
          />
          @if (can_open_okr_management) {
            <button mat-flat-button color="accent" type="button" (click)="goToCompanyObjectivesManagement()">
              <mat-icon>flag</mat-icon>
              Gestión de OKRs
            </button>
          }
        </div>
      </div>

      <section class="okr-and-metrics-section">
        @if (active_company_objective(); as objective) {
          <app-company-product-objective [objective]="objective" [show_company_product_context]="false" />
        } @else if (active_company_objective() === null && can_open_okr_management) {
          <div class="card action-card">
            <mat-icon>flag</mat-icon>
            <div class="card-header">
              <div class="card-title">
                <h2>Este producto no tiene un OKR activo</h2>
                <span class="subtitle">Define un objetivo y alinea al equipo en torno a resultados medibles.</span>
              </div>
              <button mat-stroked-button color="accent" type="button" (click)="goToCompanyObjectivesManagement()">Configurar OKR</button>
            </div>
          </div>
        }
      </section>

      <section class="okr-and-metrics-section">
        <h2 class="section-title">Métricas de método</h2>
        <app-company-product-internal-metrics [month]="selected_month()" />
      </section>

      <section id="health-metrics" class="okr-and-metrics-section">
        <h2 class="section-title">Health Metrics</h2>
        <app-company-metric [company_product_id]="company_product_id" [date]="dashboard_date()" />
      </section>
    </div>
  </div>
</div>
